import type { ReactNode } from 'react';
import { RequestRow } from '../RequestRow/RequestRow';
import type { SortKey, SortState, SupportRequest } from '../../../entities/supportRequests/model/types';
import styles from './RequestsTable.module.scss';
import React from 'react';
import { DataTable } from '../../ui/DataTable/DataTable';
import { SortableTh } from '../../ui/DataTable/SortableTh';

export interface RequestsTableProps {
    rows: SupportRequest[];
    sort: SortState;
    footer?: ReactNode;
    empty?: ReactNode;
    isLoading?: boolean;
    loading?: boolean;
    loadingText?: string;
    scrollKey?: string | number;
    onSort: (key: SortKey) => void;
    onOpen: (id: string) => void;
}

interface Column {
    key?: SortKey;
    label: string;
    className: string;
}

const COLUMNS: Column[] = [
    { key: 'id', label: 'ID', className: 'colId' },
    { label: 'Тема обращения', className: 'colTheme' },
    { label: 'Компания и автор', className: 'colOrg' },
    { key: 'date', label: 'Создан', className: 'colDate' },
    { key: 'status', label: 'Статус', className: 'colStatus' },
    { key: 'priority', label: 'Приоритет', className: 'colPrio' },
    { label: '', className: 'colGo' },
];

export function RequestsTable({
    rows,
    sort,
    footer,
    empty,
    isLoading,
    loading,
    loadingText,
    scrollKey,
    onSort,
    onOpen,
}: RequestsTableProps) {
    return (
        <DataTable
            footer={footer}
            className={styles.requests}
            scrollKey={scrollKey}
            empty={empty}
            isLoading={isLoading}
            loading={loading}
            loadingText={loadingText}
            colgroup={
                <colgroup>
                    {COLUMNS.map((c) => (
                        <col key={c.label + c.className} className={styles[c.className]} />
                    ))}
                </colgroup>
            }
            bordered={false}
        >
            <thead>
                <tr>
                    {COLUMNS.map((c) =>
                        c.key ? (
                            <SortableTh
                                key={c.label}
                                title={c.label}
                                active={sort.key === c.key}
                                dir={sort.dir === 1 ? 'asc' : 'desc'}
                                onClick={() => onSort(c.key as SortKey)}
                            />
                        ) : (
                            <th key={c.label + c.className}>{c.label}</th>
                        ),
                    )}
                </tr>
            </thead>

            <tbody>
                {rows.map((r) => (
                    <RequestRow key={r.id} request={r} onOpen={onOpen} />
                ))}
            </tbody>
        </DataTable>
    );
}